var m = require('mithril');
var prop = require('mithril/stream');
var dragscroll = require('../libs/dragscroll');
var auth = require('../auth/models/session');
var loaders = require('../layout/components/loaders');
var header = require('../layout/components/header');
var edit = require('../layout/components/edit');
var heading = require('../components/heading');
var modalForm = require('../layout/components/modalForm');
var paginationWithSearch = require('../data/components/paginationWithSearch');
var rowActionDropdown = require('../components/rowActionDropdown');
var tableColumns = require('./components/tableColumns');
var connectionModel = require('../bacnet/models/bacnetScConnection');
var scDiscoveryModal = require('../bacnet/scDiscoveryModal');
var scPresentation = require('../bacnet/scDiscoveryPresentation');
var connectionForm = modalForm(connectionModel);

var page = {};

function canEdit() {
  return edit.vm.editing() && auth.user().isSuperuser == 1;
}

function isManaged(connection) {
  return connection && Number(connection.managed) === 1;
}

function statusClass(state) {
  if (state === 'connected') return 'green';
  if (state === 'connecting' || state === 'awaiting-accept' || state === 'reconnecting' || state === 'unready') return 'yellow';
  if (state === 'error' || state === 'disconnected') return 'red';
  return 'moon-gray';
}

function connectionStatus(connection) {
  return scPresentation.hubStatus(connection);
}

function managementLabel(connection) {
  if (isManaged(connection)) return connection.managedSource || 'Cloud deployment';
  if (connection && connection.managedDetachedAt) return 'Detached from cloud';
  return 'User-managed';
}

function actionDropdown(connection, ctrl) {
  var items = [{
    label: 'Discover Devices',
    icon: 'ion-search',
    onclick: function () { scDiscoveryModal.open(ctrl.init, connection['@rid']); }
  }];
  if (!isManaged(connection)) {
    items.push(
      {
        label: 'Edit Hub',
        icon: 'ion-ios-compose',
        onclick: function () { connectionForm.editDialogue(connection, { submitCallback: ctrl.init, extrawidth: true }); }
      },
      {
        label: 'Delete Hub',
        icon: 'ion-ios-trash',
        class: 'red',
        onclick: function () { connectionForm.deleteDialogue(connection, { dashboardCallback: ctrl.init }); }
      }
    );
  }
  return m(rowActionDropdown, {
    position: 'fixed',
    align: 'left',
    items: items
  });
}

page.oninit = function () {
  var ctrl = this;
  header.vm.activeTab('BacnetConnections');
  document.title = 'nimrod | BACnet/SC Hubs';
  ctrl.newNode = prop(false);
  ctrl.connectionsToShow = [];
  ctrl.init = function () {
    return loaders.requestWithLoader({
      url: '/api/v1/bacnetscconnection',
      method: 'GET'
    }).then(function (connections) {
      ctrl.connections = connections || [];
      ctrl.newNode(true);
    });
  };
  return ctrl.init();
};

page.view = function () {
  var ctrl = this;
  if (!ctrl.connections) return m('div');
  return m('div.mh3', [
    m(heading, {
      label: 'BACnet/SC Hubs',
      class: 'f-subheadline mb3 pb1 display'
    }, [
      m('div.flex.items-center', [
        m(m.route.Link, { href: '/networks', class: 'f4 mr3' }, 'Hosts'),
        canEdit() ? m('button', {
          type: 'button',
          class: 'bn bg-transparent blue pointer f3',
          title: 'New BACnet/SC hub',
          onclick: function () { connectionForm.editDialogue({}, { submitCallback: ctrl.init, extrawidth: true }); }
        }, m('i.ion-plus')) : null
      ])
    ]),
    ctrl.connections.length === 0 ? m('p.moon-gray', [
      'No BACnet/SC hubs are configured. ',
      canEdit() ? 'Use + to create a hub profile.' : ''
    ]) : null,
    m(paginationWithSearch, {
      data: ctrl.connections,
      newNode: ctrl.newNode,
      dataToShow: ctrl.connectionsToShow,
      placeHolder: 'Search BACnet/SC hubs',
      itemsPerPage: 30,
      fieldsToSearch: ['name', 'localVmac', 'primaryHubUrl', 'failoverHubUrl', 'connectionState', 'managedSource', 'managedStatus']
    }, [
      m('div.overflow-hidden', m('div.dragscroll-container', [
        m('div.dragscroll', { oncreate: dragscroll }, [
          m('table.w-100.f4.mb4.pt3.mr4.nowrap', [
            tableColumns.colgroup([
              { key: 'name', width: '20%' },
              { key: 'vmac', width: '13%' },
              { key: 'hub', width: '24%' },
              { key: 'status', width: '12%' },
              { key: 'management', width: '25%' },
              { key: 'enabled', width: '6%' }
            ]),
            m('thead', m('tr', [
              m('th.ph0.tl', 'Name'),
              m('th.ph0.tl', 'Local VMAC'),
              m('th.ph0.tl', 'Primary Hub'),
              m('th.pl0.pr3.tl', 'Status'),
              m('th.ph0.tl', 'Management'),
              m('th.ph0.tl', 'Enabled')
            ])),
            m('tbody', ctrl.connectionsToShow.map(function (connection) {
              if (!connection || !connection['@rid']) {
                return m('tr', [
                  m('td.tl.nowrap', { 'aria-hidden': 'true' }, '\u00a0'),
                  m('td.tl.nowrap', { 'aria-hidden': 'true' }, '\u00a0'),
                  m('td.tl.nowrap', { 'aria-hidden': 'true' }, '\u00a0'),
                  m('td.tl.nowrap', { 'aria-hidden': 'true' }, '\u00a0'),
                  m('td.tl.nowrap', { 'aria-hidden': 'true' }, '\u00a0'),
                  m('td.tl.nowrap', { 'aria-hidden': 'true' }, '\u00a0')
                ]);
              }
              return m('tr', [
                m('td.tl.nowrap', m('div.flex.items-center.justify-between', [
                  canEdit() && !isManaged(connection) ? m('button.bn.bg-transparent.blue.pointer.pa0', {
                      type: 'button',
                      onclick: function () { connectionForm.editDialogue(connection, { submitCallback: ctrl.init, extrawidth: true }); }
                    }, connection.name) : m('span', connection.name),
                  canEdit() ? m('div.ml3.flex-none', actionDropdown(connection, ctrl)) : null
                ])),
                m('td.tl.nowrap.mono', {
                  title: connection.deviceUuid ? 'Device UUID: ' + connection.deviceUuid : ''
                }, connection.localVmac),
                m('td.tl.nowrap', connection.primaryHubUrl),
                m('td.tl.pr3', [
                  m('span.' + statusClass(connectionStatus(connection)), scPresentation.hubStatusLabel(connection, connectionStatus(connection))),
                  isManaged(connection) && connection.managedStatus
                    ? m('small.db.moon-gray.mt1', connection.managedStatus)
                    : null
                ]),
                m('td.tl', [
                  m('span', managementLabel(connection)),
                  connection.managedUpdatedAt
                    ? m('small.db.moon-gray.mt1', 'Synchronized ' + connection.managedUpdatedAt)
                    : null
                ]),
                m('td.tl.nowrap', Number(connection.enabled) ? 'Yes' : 'No')
              ]);
            }))
          ])
        ])
      ]))
    ])
  ]);
};

page.__test = {
  isManaged: isManaged,
  connectionStatus: connectionStatus,
  managementLabel: managementLabel,
};

module.exports = page;
